import React from "react";
import background  from '../../../assets/img/background.webp';
import { makeStyles } from "@mui/styles";

export const Background = () => {

    const classes = useStyles();

    return <div className={ classes.body } />
}

const useStyles = makeStyles({
    body: {
        width: '100vw',
        height: '100vh',
        backgroundImage: `url(${ background })`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
    }
});